import Search from "../../search/Search";
import SearchApi from "../../../api/SearchApi";
import ServiceRepair from "../../error/ServiceRepair";

const Shopping = props => {
    return (
        <Search api={SearchApi.searchShopping}/>
        // <ServiceRepair />
    )
}

export default Shopping;